module.exports = __webpack_public_path__ + "assets/img/00095.ad3a8f6c.png";